import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dropdown relative flex h-20 items-center justify-between md:mx-5" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["data-tip"]
const _hoisted_4 = {
  key: 1,
  class: "absolute right-0 z-40 mt-2 rounded-md bg-base-100 shadow-md md:min-w-[224px]"
}
const _hoisted_5 = {
  tabindex: "0",
  class: "menu rounded p-2 shadow shadow-gray-700"
}
const _hoisted_6 = {
  key: 0,
  class: "flex p-3 lg:hidden"
}
const _hoisted_7 = { class: "text-normal ml-3 flex-col items-baseline truncate p-1 font-medium" }
const _hoisted_8 = { class: "truncate text-xs font-normal" }
const _hoisted_9 = {
  key: 0,
  class: "absolute inset-0 top-18 h-1 w-full shadow-sm"
}

import {
  startCase,
} from 'lodash';
import {
  IUser,
} from 'types';
import {
  applicationStoreUrl,
} from 'utilities';
import {
  computed,
  ref,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import ProfileImageAvatar from '@/components/Helper/ProfileImageAvatar.vue';
import HeaderTextLinkButton, {
  IHeaderTextLink,
} from '@/components/NavBar/HeaderTextLinkButton.vue';
import NavLogoWithText from '@/components/NavBar/NavLogoWithText.vue';
import {
  CONSTANTS,
} from '@/helpers';
import {
  resetUserSpecificStore,
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberMenu',
  setup(__props) {

const router = useRouter();
const authStore = useStore.auth;
const isMemberMenuOpen = ref(false);

const user = computed(() => authStore.user);

const isAppLogin = computed(() => authStore.loginType === 'app');
const name = computed(() => {
  if (!user.value) {
    return '';
  }
  return startCase(`${user.value.firstName} ${user.value.lastName || ''}`);
});

const MEMBER_TEXT_LINKS: IHeaderTextLink[] = [
  {
    name: 'Dashboard', route: '/',
  },
  {
    name: 'Account', route: '/user/account',
  },
  {
    name: 'Link With App', route: '/user/link-with-app',
  },
  {
    name: 'Subscription', route: CONSTANTS.ROUTES.SUBSCRIPTION_PAGE,
  },
  {
    name: 'Contact', route: '/contact',
  },
  {
    name: 'Privacy', route: '/privacy-policy.html',
  },
  {
    name: 'Terms', route: '/terms.html',
  },
  {
    name: 'Refund', route: '/refund-policy',
  },
  {
    name: 'FAQ', route: '/faq',
  },
];

const availableTextLinks = computed(() => MEMBER_TEXT_LINKS
  .filter((l) => {
    const mainCondition = !!(!l.hidden && user.value);
    const accountCondition = l.name !== 'Account' ? true : !isAppLogin.value;
    const linkWithAppCondition = l.name !== 'Link With App' ? true
      : !isAppLogin.value && !user.value?.linkedUser;

    let subscriptionCondition = l.name !== 'Subscription' ? true : !isAppLogin.value;
    if (subscriptionCondition && user.value?.isSubscribed) {
      subscriptionCondition = !!useStore.subscription.userWebSubscription;
    }

    return mainCondition && accountCondition && linkWithAppCondition && subscriptionCondition;
  }));

function logout(loginFromApp: boolean, userPlatform?: IUser['platform']): void {
  authStore.logout();

  resetUserSpecificStore();

  if (loginFromApp) {
    window.open(
      userPlatform === 'android' ? applicationStoreUrl.google
        : applicationStoreUrl.apple,
      '_self',
    );
  } else if (router.currentRoute.value.path !== '/') {
    router.push('/');
  }
}

const isDashBoardChatRoute = computed(
  () => router.currentRoute.value.fullPath.startsWith(CONSTANTS.ROUTE_PREFIX.DASHBOARD),
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (!isDashBoardChatRoute.value)
          ? (_openBlock(), _createBlock(NavLogoWithText, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          "data-tip": name.value,
          class: _normalizeClass(["relative", {
          'md:tooltip md:tooltip-success md:tooltip-left before:overflow-hidden': !isAppLogin.value,
        }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "h-11 w-11 rounded-full",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isMemberMenuOpen.value = !isMemberMenuOpen.value))
          }, [
            (user.value)
              ? (_openBlock(), _createBlock(ProfileImageAvatar, {
                  key: 0,
                  user: user.value,
                  size: 44
                }, null, 8, ["user"]))
              : _createCommentVNode("", true)
          ]),
          (isMemberMenuOpen.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                tabindex: "-1",
                class: "fixed inset-0 z-30 h-full w-full cursor-default bg-gray-500 opacity-20",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isMemberMenuOpen.value = false))
              }))
            : _createCommentVNode("", true),
          (isMemberMenuOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                  (user.value && !isAppLogin.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createVNode(ProfileImageAvatar, {
                          user: user.value,
                          size: 50
                        }, null, 8, ["user"]),
                        _createElementVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(name.value) + " ", 1),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(user.value.username), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTextLinks.value, (item, index) => {
                    return (_openBlock(), _createBlock(HeaderTextLinkButton, {
                      key: `${item.name}_${index}`,
                      name: item.name,
                      route: item.route,
                      url: item.url,
                      event: item.event,
                      block: ""
                    }, null, 8, ["name", "route", "url", "event"]))
                  }), 128)),
                  _createVNode(HeaderTextLinkButton, {
                    name: isAppLogin.value ? 'End session' : 'Sign out',
                    block: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (logout(isAppLogin.value, user.value?.platform)))
                  }, null, 8, ["name"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3)
      ])
    ]),
    (!isDashBoardChatRoute.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : _createCommentVNode("", true)
  ], 64))
}
}

})